export enum MethodOfAssessment {
    Qualitative = 0,
    Quantitative = 1,
    DoesNotApply = 2,
}
